import React, { useState } from 'react';

import Button from '~components/Button';
import { faCopy } from '~components/icon';
import Icon from '~components/icon/Icon';
import Modal from '~components/Modal';
import { Form as WizardForm } from '~components/wizard-form';

import bulkCopyFields from '~support-at-home/forms/budgets/bulkCopy';

interface ComponentProps {
  canUpdate: boolean;
}

const BudgetBulkCopy: React.FC<ComponentProps> = ({ canUpdate }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!canUpdate) return null;
  return (
    <div className="d-flex align-items-center me-2">
      <Button id="budgets-bulk-copy-button" size="sm" onClick={() => setIsOpen(true)}>
        <Icon className="me-2" icon={faCopy} />
        Bulk Copy
      </Button>
      <Modal
        size="xl"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onClose={() => setIsOpen(false)}
        headerClassName="header"
        header="Budget Bulk Copy"
        className="budgets-bulk-copy-wizard-modal"
        includeFooter={false}
        unmountOnClose
      >
        <WizardForm steps={bulkCopyFields} onComplete={() => setIsOpen(false)} submitCaption="Close" />
      </Modal>
    </div>
  );
};

export default BudgetBulkCopy;
